import { Box, Skeleton, Theme } from "@mui/material";
import { PORTFOLIO_TABLE_LOADING_ROWS_COUNT } from "src/components-mui/pages/detail/portfolio-table-section/portfolio-table-constants";

interface IPortfolioTableSkeletonProps {
    isAnimated: boolean;
}

interface ISkeletonColumnsProps extends IPortfolioTableSkeletonProps {
    nameWidth: number;
}

const hiddenOnMobileSx = { display: ["none", "block"] };

const SkeletonColumns = ({ isAnimated, nameWidth }: ISkeletonColumnsProps) => {
    const animation = isAnimated ? "pulse" : false;

    return (
        <>
            <Box sx={{ flexGrow: 1 }}>
                <Skeleton
                    variant="rectangular"
                    animation={animation}
                    sx={{ height: theme => theme.spacing(1), width: theme => theme.spacing(nameWidth) }}
                />
            </Box>
            <Skeleton
                variant="rectangular"
                animation={animation}
                sx={{ height: theme => theme.spacing(1), width: theme => theme.spacing(8), flexShrink: 0, ml: 4 }}
            />
            {[0, 1, 2].map(columnIndex => (
                <Skeleton
                    key={columnIndex}
                    variant="rectangular"
                    animation={animation}
                    sx={{ height: theme => theme.spacing(1), width: theme => theme.spacing(8), flexShrink: 0, ml: 4, ...hiddenOnMobileSx }}
                />
            ))}
        </>
    );
};

const rowSx = { display: "flex", alignItems: "center", justifyContent: "space-between", height: (theme: Theme) => theme.spacing(8) };
const groupRowSx = { ...rowSx, borderTop: "2px solid", borderBottom: "2px solid", borderColor: "gray.100" };

export const PortfolioTableSkeleton = ({ isAnimated }: IPortfolioTableSkeletonProps) => {
    const animation = isAnimated ? "pulse" : false;

    return (
        <Box aria-hidden sx={{ "& .MuiSkeleton-root": { backgroundColor: "gray.100" } }}>
            <Box sx={rowSx}>
                <SkeletonColumns isAnimated={isAnimated} nameWidth={8} />
            </Box>
            <Box sx={groupRowSx}>
                <Skeleton variant="rectangular" animation={animation} sx={{ height: theme => theme.spacing(2), width: theme => theme.spacing(25) }} />
                <Skeleton variant="rectangular" animation={animation} sx={{ height: theme => theme.spacing(2), width: theme => theme.spacing(8) }} />
            </Box>
            {Array.from({ length: PORTFOLIO_TABLE_LOADING_ROWS_COUNT }, (_, rowIndex) => (
                <Box
                    key={rowIndex}
                    sx={{
                        ...rowSx,
                        borderBottom: rowIndex === PORTFOLIO_TABLE_LOADING_ROWS_COUNT - 1 ? undefined : "1px solid",
                        borderColor: "gray.100",
                    }}
                >
                    <SkeletonColumns isAnimated={isAnimated} nameWidth={15} />
                </Box>
            ))}
            <Box sx={groupRowSx}>
                <Skeleton variant="rectangular" animation={animation} sx={{ height: theme => theme.spacing(2), width: theme => theme.spacing(14) }} />
                <Skeleton variant="rectangular" animation={animation} sx={{ height: theme => theme.spacing(2), width: theme => theme.spacing(8) }} />
            </Box>
        </Box>
    );
};
